module.exports = {
      id: "search-usage",
      viewBox: "0 0 512 512",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#search",
      toString: function () {
        return this.url;
      }
    }